import { useTranslation } from '@thoughtspot/i18n';
import { Vertical } from '@thoughtspot/radiant-react/widgets/layout';
import { Modal, ModalSize } from '@thoughtspot/radiant-react/widgets/modal';
import React from 'react';
import { HelpMenuState } from "./help-menu.const";
export const GettingStartedModal = ({ setHelpMenuState, learningModule, }) => {
    const { t } = useTranslation();
    return (React.createElement(Modal, { isOpen: true, size: ModalSize.FULLSCREEN, title: t('helpMenuItems.gettingStarted.label'), confirmButton: {
            text: t('CLOSE'),
            onConfirm: () => {
                setHelpMenuState(HelpMenuState.CLOSED);
            },
        }, onDismiss: () => {
            setHelpMenuState(HelpMenuState.CLOSED);
        } },
        React.createElement(Vertical, { grow: true }, learningModule)));
};
//# sourceMappingURL=getting-started-modal.js.map